// <div data-controller="admin--image-upload">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "fileId", "filePictureId", "fileUrl", "filePreview" ];
  static classes = [ "" ]
  static values = {
    fileKind: String,
    uploadUrl: String
  };

  initialize() {

  }

  onFileInputChange(e) {
    let file = e.target.files[0];
    if (file) {
      this.upload(file);
    }
  }

  upload(file) {
    let formData = new FormData();
    formData.append("image[file]", file);
    formData.append("image[kind]", this.fileKindValue);

    api.post(this.uploadUrlValue, formData, {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    }).then((response) => {
      const { file_url, id, picture_id, kind } = response.data;

      if (this.hasFileIdTarget) {
        this.fileIdTarget.value = id;
      }
      if (this.hasFilePictureIdTarget) {
        this.filePictureIdTarget.value = picture_id;
      }
      if (this.hasFileUrlTarget) {
        this.fileUrlTarget.value = file_url;
      }
      if (this.hasFilePreviewTarget) {
        this.filePreviewTarget.src = file_url;
      }
    }).catch((error) => {
      console.log(error.response.data, error);
      alert("업로드 실패");
    })
  }

  connect() {

  }

  disconnect() {

  }
}